(() => {
  'use strict';

  const signs = [
    {
      key:'aries', tr:'Koç', en:'Aries', glyph:'♈', elementTr:'Ateş', elementEn:'Fire', modeTr:'Öncü', modeEn:'Cardinal',
      themesTr:['Cesaret','Canlılık','Özgüven'], themesEn:['Courage','Vitality','Confidence'],
      copyTr:'Koç sembolizminde başlangıç enerjisi, doğrudanlık ve harekete geçme isteği öne çıkar. Asteria yorumunda bu çizgi cesaret, canlılık ve kendine güven temalarıyla eşleşir.',
      copyEn:'In Aries symbolism, initiative, directness, and the drive to act stand out. In Asteria’s reading, this pattern connects with courage, vitality, and confidence.',
      stones:['Turuncu Akik','Kaplan Gözü','Kırmızı Jasper','Mercan','Lav Taşı'],
      products:[
        ['1206','turuncu-akik-yesil-kaplan-gozu-nazara-karsi-etkili-sans-ve-sifa-icin-bileklik-1206'],
        ['436','lav-tasi-ve-turuncu-akik-nazar-koruyucu-enerji-bilekligi'],
        ['1207','kaplan-gozu-akik-mercan-enerji-veren-nazara-karsi-etkili-bileklik-1207']
      ]
    },
    {
      key:'taurus', tr:'Boğa', en:'Taurus', glyph:'♉', elementTr:'Toprak', elementEn:'Earth', modeTr:'Sabit', modeEn:'Fixed',
      themesTr:['Denge','Zarafet','Topraklanma'], themesEn:['Balance','Elegance','Grounding'],
      copyTr:'Boğa sembolizminde istikrar, değer duygusu ve kalıcılık öne çıkar. Asteria yorumunda bu çizgi denge, zarafet ve sağlamlık temalarıyla eşleşir.',
      copyEn:'In Taurus symbolism, steadiness, value, and continuity stand out. In Asteria’s reading, this pattern connects with balance, elegance, and grounding.',
      stones:['Pembe Kuvars','Jade / Yeşim','Yeşil Akik','İnci','Aventurin'],
      products:[
        ['172','inci-pembe-ceyt-iki-sirali-ozguven-huzur-ve-zarafet-kolyesi-172'],
        ['439','yesil-akik-i̇nci-nazar-korumasi-sans-ve-denge-i̇cin-kolye-bileklik-seti'],
        ['12001','premium-serisi-pembe-kuvars-kolye-12001']
      ]
    },
    {
      key:'gemini', tr:'İkizler', en:'Gemini', glyph:'♊', elementTr:'Hava', elementEn:'Air', modeTr:'Değişken', modeEn:'Mutable',
      themesTr:['İletişim','Berraklık','Öğrenme'], themesEn:['Communication','Clarity','Learning'],
      copyTr:'İkizler sembolizminde merak, zihinsel hareket ve bilgi alışverişi öne çıkar. Asteria yorumunda bu çizgi iletişim, berraklık ve öğrenme temalarıyla eşleşir.',
      copyEn:'In Gemini symbolism, curiosity, mental movement, and the exchange of ideas stand out. In Asteria’s reading, this pattern connects with communication, clarity, and learning.',
      stones:['Apatit','Mavi Akik','Sodalit','Mavi Kuvars','Lapis Lazuli'],
      products:[
        ['107','havlit-apatit-pembe-akik-3-sirali-huzuriletisim-zihinsel-berrakli-kolyesi-107'],
        ['1203','lapis-kehribar-pozitif-enerji-netlik-ve-bilgelik-bilekligi-1203'],
        ['12116','lapis-mercan-bilgelik-ve-sezgi-icin-elit-bileklik-12116']
      ]
    },
    {
      key:'cancer', tr:'Yengeç', en:'Cancer', glyph:'♋', elementTr:'Su', elementEn:'Water', modeTr:'Öncü', modeEn:'Cardinal',
      themesTr:['Sevgi','Uyum','Sezgi'], themesEn:['Love','Harmony','Intuition'],
      copyTr:'Yengeç sembolizminde bağ kurma, koruyucu duyarlılık ve duygusal hafıza öne çıkar. Asteria yorumunda bu çizgi sevgi, uyum ve sezgi temalarıyla eşleşir.',
      copyEn:'In Cancer symbolism, connection, protective sensitivity, and emotional memory stand out. In Asteria’s reading, this pattern connects with love, harmony, and intuition.',
      stones:['Pembe Kuvars','İnci','Sedef','Ametist','Pembe Akik'],
      products:[
        ['172','inci-pembe-ceyt-iki-sirali-ozguven-huzur-ve-zarafet-kolyesi-172'],
        ['176','inci-mavi-pembe-akik-stres-azaltma-zihinsel-berraklik-ve-bereket-kolye-bileklik-seti-176'],
        ['309','pembe-sedef-pembe-kuvars-ask-ve-zarafet-kolye-bileklik-seti-309']
      ]
    },
    {
      key:'leo', tr:'Aslan', en:'Leo', glyph:'♌', elementTr:'Ateş', elementEn:'Fire', modeTr:'Sabit', modeEn:'Fixed',
      themesTr:['Özgüven','Canlılık','Büyüme'], themesEn:['Confidence','Vitality','Growth'],
      copyTr:'Aslan sembolizminde görünürlük, yaratıcı ifade ve yaşam enerjisi öne çıkar. Asteria yorumunda bu çizgi özgüven, canlılık ve büyüme temalarıyla eşleşir.',
      copyEn:'In Leo symbolism, visibility, creative expression, and life force stand out. In Asteria’s reading, this pattern connects with confidence, vitality, and growth.',
      stones:['Turuncu Akik','Sarı Akik','Kaplan Gözü','Kehribar','Peridot'],
      products:[
        ['1206','turuncu-akik-yesil-kaplan-gozu-nazara-karsi-etkili-sans-ve-sifa-icin-bileklik-1206'],
        ['224','premium-serisi-kaplan-gozu-zebercet-kristal-cesaret-sans-ve-pozitif-enerji-kolyesi-224'],
        ['85','lav-tasi-kaplan-gozu-kehribar-guc-cesaret-ve-huzur-taki-seti-85']
      ]
    },
    {
      key:'virgo', tr:'Başak', en:'Virgo', glyph:'♍', elementTr:'Toprak', elementEn:'Earth', modeTr:'Değişken', modeEn:'Mutable',
      themesTr:['Odak','Disiplin','Berraklık'], themesEn:['Focus','Discipline','Clarity'],
      copyTr:'Başak sembolizminde düzen, ayrıntı ve işleyen bir sistem kurma isteği öne çıkar. Asteria yorumunda bu çizgi odak, disiplin ve berraklık temalarıyla eşleşir.',
      copyEn:'In Virgo symbolism, order, detail, and the desire to create workable systems stand out. In Asteria’s reading, this pattern connects with focus, discipline, and clarity.',
      stones:['Hematit','Dumanlı Kuvars','Necef Taşı','Sodalit','Beyaz Akik'],
      products:[
        ['220','hematit-dumanli-akik-kristal-nazardan-korunma-canlilik-ve-odaklanma-kolyesi-220'],
        ['263','necef-tasi-hematit-havlit-3-sirali-sifa-ve-pozitif-enerji-kolyesi-263'],
        ['384','sodalit-hematit-guc-kararlilik-ve-ozguven-kolye-bileklik-seti-384']
      ]
    },
    {
      key:'libra', tr:'Terazi', en:'Libra', glyph:'♎', elementTr:'Hava', elementEn:'Air', modeTr:'Öncü', modeEn:'Cardinal',
      themesTr:['Denge','Uyum','Zarafet'], themesEn:['Balance','Harmony','Elegance'],
      copyTr:'Terazi sembolizminde ilişki, karşılıklılık ve estetik denge öne çıkar. Asteria yorumunda bu çizgi denge, uyum ve zarafet temalarıyla eşleşir.',
      copyEn:'In Libra symbolism, relationship, reciprocity, and aesthetic balance stand out. In Asteria’s reading, this pattern connects with balance, harmony, and elegance.',
      stones:['Pembe Kuvars','Jade / Yeşim','Yeşil Akik','İnci','Mavi Akik'],
      products:[
        ['172','inci-pembe-ceyt-iki-sirali-ozguven-huzur-ve-zarafet-kolyesi-172'],
        ['18','gercek-inci-mavi-akik-turuncu-akik-zarafet-iletisim-ve-nazardan-korunma-kolye-bileklik-seti-18'],
        ['422','inci-mavi-akik-sakinlik-ve-koruma-enerjili-premium-kolye-422']
      ]
    },
    {
      key:'scorpio', tr:'Akrep', en:'Scorpio', glyph:'♏', elementTr:'Su', elementEn:'Water', modeTr:'Sabit', modeEn:'Fixed',
      themesTr:['Dönüşüm','Cesaret','Sınırlar'], themesEn:['Transformation','Courage','Boundaries'],
      copyTr:'Akrep sembolizminde yoğunluk, değişim ve içsel dayanıklılık öne çıkar. Asteria yorumunda bu çizgi dönüşüm, cesaret ve sınır temalarıyla eşleşir.',
      copyEn:'In Scorpio symbolism, intensity, change, and inner resilience stand out. In Asteria’s reading, this pattern connects with transformation, courage, and boundaries.',
      stones:['Lav Taşı','Kırmızı Jasper','Malahit','Oniks','Ametist'],
      products:[
        ['402','nazar-korumasi-guc-ve-denge-icin-oniks-malahit-akik-bileklik-402'],
        ['425','oniks-malakit-guc-ve-nazar-koruma-enerjili-dogal-tas-kolye-425'],
        ['139','lav-tasi-mercan-enerji-tutku-ve-nazardan-korunma-kolyesi-139']
      ]
    },
    {
      key:'sagittarius', tr:'Yay', en:'Sagittarius', glyph:'♐', elementTr:'Ateş', elementEn:'Fire', modeTr:'Değişken', modeEn:'Mutable',
      themesTr:['Büyüme','Bilgelik','Fırsat'], themesEn:['Growth','Wisdom','Opportunity'],
      copyTr:'Yay sembolizminde keşif, ufuk genişletme ve anlam arayışı öne çıkar. Asteria yorumunda bu çizgi büyüme, öğrenme ve fırsat temalarıyla eşleşir.',
      copyEn:'In Sagittarius symbolism, exploration, expanding horizons, and the search for meaning stand out. In Asteria’s reading, this pattern connects with growth, learning, and opportunity.',
      stones:['Aventurin','Peridot','Lapis Lazuli','Turkuaz','Apatit'],
      products:[
        ['393','aventurin-lapis-jasper-2-sirali-sans-bolluk-ve-huzur-kolye-ve-bileklik-seti-393'],
        ['115','peridot-yesim-iki-sirali-canlilik-nese-ve-pozitif-enerji-kolyesi-115'],
        ['13032','zebercet-peridot-negatif-enerji-kalkani-bileklik-13032']
      ]
    },
    {
      key:'capricorn', tr:'Oğlak', en:'Capricorn', glyph:'♑', elementTr:'Toprak', elementEn:'Earth', modeTr:'Öncü', modeEn:'Cardinal',
      themesTr:['Disiplin','Odak','Topraklanma'], themesEn:['Discipline','Focus','Grounding'],
      copyTr:'Oğlak sembolizminde yapı, sorumluluk ve uzun vadeli hedefler öne çıkar. Asteria yorumunda bu çizgi disiplin, odak ve sağlamlık temalarıyla eşleşir.',
      copyEn:'In Capricorn symbolism, structure, responsibility, and long-term goals stand out. In Asteria’s reading, this pattern connects with discipline, focus, and grounding.',
      stones:['Hematit','Dumanlı Kuvars','Oniks','Larvikit','İmparator Jasper'],
      products:[
        ['220','hematit-dumanli-akik-kristal-nazardan-korunma-canlilik-ve-odaklanma-kolyesi-220'],
        ['250','hematit-oniks-kristal-enerji-zihin-ve-nazardan-koruma-kolyesi-250'],
        ['258','hematit-oniks-kristal-uc-sirali-enerji-zihin-ve-nazardan-koruma-kolyesi-258']
      ]
    },
    {
      key:'aquarius', tr:'Kova', en:'Aquarius', glyph:'♒', elementTr:'Hava', elementEn:'Air', modeTr:'Sabit', modeEn:'Fixed',
      themesTr:['Berraklık','Bilgelik','Dönüşüm'], themesEn:['Clarity','Wisdom','Transformation'],
      copyTr:'Kova sembolizminde bağımsız düşünme, farklı bakış açıları ve yenilik öne çıkar. Asteria yorumunda bu çizgi berraklık, öğrenme ve dönüşüm temalarıyla eşleşir.',
      copyEn:'In Aquarius symbolism, independent thinking, new perspectives, and innovation stand out. In Asteria’s reading, this pattern connects with clarity, learning, and transformation.',
      stones:['Apatit','Sodalit','Lapis Lazuli','Mavi Kuvars','Ametist'],
      products:[
        ['76','7-renk-cakra-seti-76'],
        ['107','havlit-apatit-pembe-akik-3-sirali-huzuriletisim-zihinsel-berrakli-kolyesi-107'],
        ['1203','lapis-kehribar-pozitif-enerji-netlik-ve-bilgelik-bilekligi-1203']
      ]
    },
    {
      key:'pisces', tr:'Balık', en:'Pisces', glyph:'♓', elementTr:'Su', elementEn:'Water', modeTr:'Değişken', modeEn:'Mutable',
      themesTr:['Sezgi','Sakinlik','Bilgelik'], themesEn:['Intuition','Calm','Wisdom'],
      copyTr:'Balık sembolizminde sezgi, duyarlılık ve anlam arayışı öne çıkar. Asteria yorumunda bu çizgi sezgi, sakinlik ve bilgelik temalarıyla eşleşir.',
      copyEn:'In Pisces symbolism, intuition, sensitivity, and the search for meaning stand out. In Asteria’s reading, this pattern connects with intuition, calm, and wisdom.',
      stones:['Ametist','Mor Akik','Lapis Lazuli','Sodalit','İnci'],
      products:[
        ['76','7-renk-cakra-seti-76'],
        ['275','elit-serisi-ametist-inci-ruhsal-arinma-depresyon-azaltma-ve-ic-huzur-kolyesi-275'],
        ['285','premium-serisi-ametist-inci-2-sirali-saflik-ve-huzur-enerji-kolyesi-285']
      ]
    }
  ];

  const routes = {
    'Turuncu Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Kaplan Gözü': {profile:'kaplan-gozu-tasi', collection:'kaplan-gozu-tasi-iceren-urunler'},
    'Kırmızı Jasper': {profile:'jasper-tasi', collection:'jasper-tasi-iceren-urunler'},
    'Mercan': {profile:'mercan', collection:'mercan-tasi-iceren-urunler'},
    'Lav Taşı': {profile:'lav-tasi', collection:'lav-tasi-iceren-urunler'},
    'Pembe Kuvars': {profile:'kuvars-tasi', collection:'kuvars-tasi-iceren-urunler'},
    'Jade / Yeşim': {profile:'jade-yesim-ceyt-tasi', collection:'yesim-tasi-i̇ceren-urunler'},
    'Yeşil Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'İnci': {profile:'inci', collection:'i̇nci-tasi-i̇ceren-urunler'},
    'Aventurin': {profile:'aventurin-tasi', collection:'aventurin-tasi-iceren-urunler'},
    'Apatit': {profile:'apatit-tasi', collection:'apatit-tasi-iceren-urunler'},
    'Mavi Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Sodalit': {profile:'sodalit-tasi', collection:'sodalit-tasi-iceren-urunler'},
    'Mavi Kuvars': {profile:'kuvars-tasi', collection:'kuvars-tasi-iceren-urunler'},
    'Lapis Lazuli': {profile:'lapis-lazuli-tasi', collection:'lapis-tasi-iceren-urunler'},
    'Sedef': {profile:'sedef', collection:'sedef-tasi-iceren-urunler'},
    'Ametist': {profile:'ametist-tasi', collection:'ametist-tasi-iceren-urunler'},
    'Pembe Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Sarı Akik': {profile:'akik-tasi', collection:null, mode:'info_custom_order'},
    'Kehribar': {profile:'kehribar-tasi', collection:'kehribar-tasi-iceren-urunler'},
    'Peridot': {profile:'peridot-tasi', collection:'peridot-tasi-iceren-urunler'},
    'Hematit': {profile:'hematit-tasi', collection:'hematit-tasi-iceren-urunler'},
    'Dumanlı Kuvars': {profile:'kuvars-tasi', collection:'kuvars-tasi-iceren-urunler'},
    'Necef Taşı': {profile:'necef-tasi', collection:'necef-tasi-iceren-urunler'},
    'Beyaz Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Malahit': {profile:'malahit-tasi', collection:'malahit-tasi-iceren-urunler'},
    'Oniks': {profile:'oniks-tasi', collection:'oniks-tasi-iceren-urunler'},
    'Turkuaz': {profile:'turkuaz-tasi', collection:'turkuaz-tasi-iceren-urunler'},
    'Larvikit': {profile:'larvikit-tasi', collection:'larvikit-tasi-iceren-urunler'},
    'İmparator Jasper': {profile:'jasper-tasi', collection:'jasper-tasi-iceren-urunler'},
    'Mor Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Havlit': {profile:'havlit-tasi', collection:'havlit-tasi-iceren-urunler'},
    'Kalsedon': {profile:'kalsedon-tasi', collection:'kalsedon-tasi-iceren-urunler'},
    'Akuamarin': {profile:'akuamarin-tasi', collection:'akuamarin-tasi-iceren-urunler'},
    'Beyaz Kuvars': {profile:'kuvars-tasi', collection:'kuvars-tasi-iceren-urunler'},
    'Necef': {profile:'necef-tasi', collection:'necef-tasi-iceren-urunler'},
    'Jasper': {profile:'jasper-tasi', collection:'jasper-tasi-iceren-urunler'},
    'Akik': {profile:'akik-tasi', collection:'akik-tasi-iceren-urunler'},
    'Mavi Jasper': {profile:'jasper-tasi', collection:null, mode:'info_custom_order'}
  };

  globalThis.AsteriaZodiacData = Object.freeze({signs, routes});
})();